import React from 'react';
import { Box, Card, CardContent, Container, Grid, Typography } from '@material-ui/core';

const KeyBenefitsCardGrid = ({ sectionConfig = {}, layoutContext = {} }) => {
    const { applyHoverEffect, removeHoverEffect, getIcon, getAnimationProps } = layoutContext;
    const items = sectionConfig.items || [];

    if (!items.length) {
        return null;
    }

    const applyAnimation = (animationConfig, index = 0) => (
        typeof getAnimationProps === 'function' ? getAnimationProps(animationConfig, index) : {}
    );
    const sectionAnimation = applyAnimation(sectionConfig.animation?.section);
    const titleAnimation = applyAnimation(sectionConfig.animation?.title);

    return (
        <Box
            id="keybenefits-section"
            className={sectionAnimation.className}
            data-anim={sectionAnimation.dataAnim}
            data-delay={sectionAnimation.dataDelay}
            data-trigger-once={sectionAnimation.dataTriggerOnce}
            style={{ ...(sectionConfig.styles || {}), ...(sectionAnimation.style || {}) }}
        >
            <Container maxWidth={sectionConfig.container?.maxWidth || 'lg'} style={sectionConfig.containerStyles || {}}>
                <Box
                    className={titleAnimation.className}
                    data-anim={titleAnimation.dataAnim}
                    data-delay={titleAnimation.dataDelay}
                    data-trigger-once={titleAnimation.dataTriggerOnce}
                    style={{ ...(sectionConfig.titleContainerStyles || {}), ...(titleAnimation.style || {}) }}
                >
                    {sectionConfig.label && (
                        <Typography variant={sectionConfig.typography?.label?.variant || 'body2'} style={sectionConfig.labelStyles || {}}>
                            {sectionConfig.label}
                        </Typography>
                    )}
                    <Typography variant={sectionConfig.typography?.title?.variant || 'h3'} style={sectionConfig.titleStyles || {}}>
                        {sectionConfig.title}
                    </Typography>
                    {sectionConfig.subtitle && (
                        <Typography variant={sectionConfig.typography?.subtitle?.variant || 'body1'} style={sectionConfig.subtitleStyles || {}}>
                            {sectionConfig.subtitle}
                        </Typography>
                    )}
                </Box>
                <Grid container spacing={sectionConfig.grid?.spacing || 4}>
                    {items.map((benefit, index) => {
                        const cardAnimation = applyAnimation(sectionConfig.animation?.items, index);
                        const iconContainerStyles = {
                            ...(sectionConfig.iconContainerStyles || {}),
                            background: benefit.iconBackgroundColor || sectionConfig.iconContainerStyles?.background,
                            color: benefit.iconColor || sectionConfig.iconContainerStyles?.color
                        };
                        const iconStyles = {
                            ...(sectionConfig.iconStyles || {}),
                            color: benefit.iconColor || sectionConfig.iconStyles?.color
                        };
                        return (
                            <Grid
                                item
                                xs={sectionConfig.gridItem?.xs || 12}
                                sm={sectionConfig.gridItem?.sm || 6}
                                md={sectionConfig.gridItem?.md || 4}
                                key={`keybenefit-${index}`}
                            >
                                <Card
                                    className={cardAnimation.className}
                                    data-anim={cardAnimation.dataAnim}
                                    data-delay={cardAnimation.dataDelay}
                                    data-trigger-once={cardAnimation.dataTriggerOnce}
                                    style={{ ...(sectionConfig.cardStyles || {}), ...(cardAnimation.style || {}) }}
                                    onMouseEnter={(event) => applyHoverEffect?.(event, sectionConfig.cardHoverStyles || {})}
                                    onMouseLeave={(event) => removeHoverEffect?.(event, sectionConfig.cardStyles || {})}
                                >
                                    <CardContent style={sectionConfig.cardContentStyles || {}}>
                                        <Box style={iconContainerStyles}>{getIcon?.(benefit.icon, iconStyles)}</Box>
                                        <Typography variant={sectionConfig.typography?.cardTitle?.variant || 'h6'} style={sectionConfig.cardTitleStyles || {}}>
                                            {benefit.title}
                                        </Typography>
                                        <Typography variant={sectionConfig.typography?.cardDescription?.variant || 'body2'} style={sectionConfig.cardDescriptionStyles || {}}>
                                            {benefit.description}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        );
                    })}
                </Grid>
            </Container>
        </Box>
    );
};

export default KeyBenefitsCardGrid;
